<template lang="pug">
div
	div(:loading="$apollo.loading")
		highcharts(v-if="pieChartOptions", class="hc", :options="pieChartOptions", ref="piechart")
</template>

<script>
import Vue from "vue";
import gql from "graphql-tag";
import Highcharts from "highcharts";
import HighchartsVue from 'highcharts-vue'
import moment from "moment";

Vue.use(HighchartsVue, {
	highcharts: Highcharts
})

export default {
    name: "MisBreakdown",
    props: ["companyId"],
	data() {
		return {
			pieChartOptions: null
		}	
	},
	watch: { 
      CompanyMetabase: function(val) {
          if (val) {
                let total = 0
                const series = val.rows.map(row => {
                    total = total + row.count
                    return [row.identity, row.count];
                });

                this.pieChartOptions = {
                    chart: { 
                        type: "pie"
                    },
                    plotOptions: {
                        pie: {
                            shadow: false,
                            innerSize: '40%',
                            cursor: 'pointer',
                                dataLabels: {
                                enabled: true,
                                format: '<b>{point.name}</b>: {point.percentage:.2f} %'
                            },
                        }
                    },
                    title: {  text: "MIS Breakdown"  },
                    subtitle: {  text: "Total: " + total  },
                    series: [
                        {   name: "Count", 
                            data: series
                        }
                    ]
                }    
          }
      }
  	},
	apollo: {
		CompanyMetabase: {
			query: gql`
				query CompanyMetabase($company_id: String!, $card_id: Int!) {
					CompanyMetabase(company_id: $company_id, card_id: $card_id) {
						columns {
							identity
							count
						}
						cols {
							name
						}
						rows {
							identity
							count
						}
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					company_id: this.companyId,
					card_id: 72
				};
            },
            update: r => r.CompanyMetabase
		}
	}
};
</script>
